export const es = {
  menu: {
    admin: {
      root: 'Administración',
      organizations: 'Organizaciones',
      users: 'Usuarios',
      aiManagement: 'Gestión de IA',
      agents: 'Agentes',
      aiAgents: 'Agentes',
      aiUsage: 'Uso',
    },
  },
  aiManagement: {
    loading: {
      agent: 'Cargando agente...',
      usageData: 'Cargando datos de uso...',
    },
    errors: {
      agentNotFound: 'Error al cargar el agente',
      organizationNotFound: 'Organización no encontrada',
    },
    tools: {
      names: {
        'crm-account-list': 'List Accounts',
        'crm-account-get': 'Get Account',
        'crm-account-create': 'Create Account',
        'crm-contact-list': 'List Contacts',
        'crm-account-delete': 'Delete Account',
        'crm-account-update': 'Update Account',
        'crm-accountAddress-create': 'Create Account Address',
        'crm-accountAddress-delete': 'Delete Account Address',
        'crm-accountAddress-get': 'Get Account Address',
        'crm-accountAddress-list': 'List Account Addresses',
        'crm-accountAddress-update': 'Update Account Address',
        'crm-contact-create': 'Create Contact',
        'crm-contact-delete': 'Delete Contact',
        'crm-contact-get': 'Get Contact',
        'crm-contact-update': 'Update Contact',
        'crm-customerInvitation-accept': 'Accept Customer Invitation',
        'crm-customerInvitation-cancel': 'Cancel Customer Invitation',
        'crm-customerInvitation-create': 'Create Customer Invitation',
        'crm-customerInvitation-get': 'Get Customer Invitation',
        'crm-customerInvitation-getByToken': 'Get Customer Invitation by Token',
        'crm-customerInvitation-list': 'List Customer Invitations',

        'sales-salesOrder-list': 'List Sales Orders',
        'sales-salesOrder-get': 'Get Sales Order',
        'sales-booking-create': 'Create Booking',
        'sales-booking-get': 'Get Booking',
        'sales-booking-list': 'List Bookings',
        'sales-booking-update': 'Update Booking',
        'sales-deductionType-create': 'Create Deduction Type',
        'sales-deductionType-delete': 'Delete Deduction Type',
        'sales-deductionType-get': 'Get Deduction Type',
        'sales-deductionType-list': 'List Deduction Types',
        'sales-deductionType-update': 'Update Deduction Type',
        'sales-load-create': 'Create Load',
        'sales-load-get': 'Get Load',
        'sales-load-list': 'List Loads',
        'sales-load-update': 'Update Load',
        'sales-loadReconciliation-delete': 'Delete Load Reconciliation',
        'sales-loadReconciliation-update': 'Update Load Reconciliation',
        'sales-salesOrder-create': 'Create Sales Order',
        'sales-salesOrder-update': 'Update Sales Order',
        'inventory-item-list': 'List Inventory Items',
        'inventory-item-get': 'Get Inventory Item',
        'inventory-category-create': 'Create Category',
        'inventory-category-delete': 'Delete Category',
        'inventory-category-get': 'Get Category',
        'inventory-category-list': 'List Categories',
        'inventory-category-update': 'Update Category',
        'inventory-inventoryTag-create': 'Create Inventory Tag',
        'inventory-inventoryTag-delete': 'Delete Inventory Tag',
        'inventory-inventoryTag-get': 'Get Inventory Tag',
        'inventory-inventoryTag-list': 'List Inventory Tags',
        'inventory-inventoryTag-update': 'Update Inventory Tag',
        'inventory-item-create': 'Create Item',
        'inventory-item-delete': 'Delete Item',
        'inventory-item-update': 'Update Item',
        'inventory-itemGroup-create': 'Create Item Group',
        'inventory-itemGroup-delete': 'Delete Item Group',
        'inventory-itemGroup-get': 'Get Item Group',
        'inventory-itemGroup-list': 'List Item Groups',
        'inventory-itemGroup-update': 'Update Item Group',
        'core-customAttribute-create': 'Create Custom Attribute',
        'core-customAttribute-delete': 'Delete Custom Attribute',
        'core-customAttribute-get': 'Get Custom Attribute',
        'core-customAttribute-list': 'List Custom Attributes',
        'core-customAttribute-update': 'Update Custom Attribute',
        'core-customAttribute-validate': 'Validate Custom Attribute',
        'core-facility-create': 'Create Facility',
        'core-facility-get': 'Get Facility',
        'core-facility-list': 'List Facilities',
        'core-facilityGroup-assignFacility':
          'Assign Facility to Facility Group',
        'core-facilityGroup-create': 'Create Facility Group',
        'core-facilityGroup-get': 'Get Facility Group',
        'core-facilityGroup-list': 'List Facility Groups',
        'core-facilityGroup-removeFacility':
          'Remove Facility from Facility Group',
        'core-facilityGroup-update': 'Update Facility Group',
        'core-organization-create': 'Create Organization',
        'core-organization-delete': 'Delete Organization',
        'core-organization-get': 'Get Organization',
        'core-organization-list': 'List Organizations',
        'core-organization-update': 'Update Organization',
        'core-scopedSettingValues-getBySetting': 'Get Scoped Setting Values',
        'core-scopedSettingValues-patch': 'Patch Scoped Setting Values',
        'core-setting-create': 'Create Setting',
        'core-setting-delete': 'Delete Setting',
        'core-setting-get': 'Get Setting',
        'core-setting-list': 'List Settings',
        'core-setting-update': 'Update Setting',
        'core-settingsGroup-create': 'Create Settings Group',
        'core-settingsGroup-delete': 'Delete Settings Group',
        'core-settingsGroup-get': 'Get Settings Group',
        'core-settingsGroup-list': 'List Settings Groups',
        'core-settingsGroup-update': 'Update Settings Group',
        'core-user-create': 'Create User',
        'core-user-get': 'Get User',
        'core-user-list': 'List Users',
        'files-file-generateAccessURL': 'Generate File Access URL',
        'files-file-get': 'Get File',
        'files-file-list': 'List Files',
        'files-fileTemplate-get': 'Get File Template',
        'files-fileTemplate-list': 'List File Templates',
        'files-fileTemplate-set': 'Set File Template',
        'files-fileTemplate-remove': 'Remove File Template',
        'finance-bill-create': 'Create Bill',
        'finance-bill-get': 'Get Bill',
        'finance-bill-list': 'List Bills',
        'finance-financialAccount-create': 'Create Financial Account',
        'finance-financialAccount-list': 'List Financial Accounts',
        'finance-invoice-create': 'Create Invoice',
        'finance-invoice-get': 'Get Invoice',
        'finance-invoice-list': 'List Invoices',
        'finance-payment-create': 'Create Payment',
        'finance-payment-list': 'List Payments',
        'general-chart-create': 'Create Chart',
        'general-dateTime': 'Get Date/Time',
        'general-python-execute': 'Execute Python Code',
        'general-userInput': 'Request User Input',
        'purchases-purchaseOrder-list': 'List Purchase Orders',
        'purchases-purchaseOrder-get': 'Get Purchase Order',
        'purchases-purchaseOrder-create': 'Create Purchase Order',
        'purchases-purchaseOrder-update': 'Update Purchase Order',
        'transportation-asset-create': 'Create Asset',
        'transportation-asset-delete': 'Delete Asset',
        'transportation-asset-get': 'Get Asset',
        'transportation-asset-list': 'List Assets',
        'transportation-asset-update': 'Update Asset',
        'transportation-assetType-create': 'Create Asset Type',
        'transportation-assetType-delete': 'Delete Asset Type',
        'transportation-assetType-get': 'Get Asset Type',
        'transportation-assetType-list': 'List Asset Types',
        'transportation-assetType-update': 'Update Asset Type',
        'transportation-containerType-create': 'Create Container Type',
        'transportation-containerType-delete': 'Delete Container Type',
        'transportation-containerType-get': 'Get Container Type',
        'transportation-containerType-list': 'List Container Types',
        'transportation-containerType-update': 'Update Container Type',
        'transportation-driver-create': 'Create Driver',
        'transportation-driver-get': 'Get Driver',
        'transportation-driver-list': 'List Drivers',
        'transportation-driver-update': 'Update Driver',
        'transportation-freightForwarder-create': 'Create Freight Forwarder',
        'transportation-freightForwarder-delete': 'Delete Freight Forwarder',
        'transportation-freightForwarder-get': 'Get Freight Forwarder',
        'transportation-freightForwarder-list': 'List Freight Forwarders',
        'transportation-freightForwarder-update': 'Update Freight Forwarder',
        'transportation-freightLine-create': 'Create Freight Line',
        'transportation-freightLine-delete': 'Delete Freight Line',
        'transportation-freightLine-get': 'Get Freight Line',
        'transportation-freightLine-list': 'List Freight Lines',
        'transportation-freightLine-update': 'Update Freight Line',
        'transportation-hauler-add': 'Add Hauler',
        'transportation-hauler-remove': 'Remove Hauler',
        'transportation-route-create': 'Create Route',
        'transportation-route-get': 'Get Route',
        'transportation-route-list': 'List Routes',
        'transportation-route-update': 'Update Route',
        'transportation-shippingCarrier-create': 'Create Shipping Carrier',
        'transportation-shippingCarrier-delete': 'Delete Shipping Carrier',
        'transportation-shippingCarrier-get': 'Get Shipping Carrier',
        'transportation-shippingCarrier-list': 'List Shipping Carriers',
        'transportation-shippingCarrier-update': 'Update Shipping Carrier',
        'transportation-task-create': 'Create Task',
        'transportation-task-get': 'Get Task',
        'transportation-task-list': 'List Tasks',
        'transportation-task-update': 'Update Task',
        'transportation-trailer-create': 'Create Trailer',
        'transportation-trailer-get': 'Get Trailer',
        'transportation-trailer-list': 'List Trailers',
        'transportation-trailer-update': 'Update Trailer',
        'transportation-transportationType-create':
          'Create Transportation Type',
        'transportation-transportationType-delete':
          'Delete Transportation Type',
        'transportation-transportationType-get': 'Get Transportation Type',
        'transportation-transportationType-list': 'List Transportation Types',
        'transportation-transportationType-update':
          'Update Transportation Type',
        'transportation-truck-create': 'Create Truck',
        'transportation-truck-get': 'Get Truck',
        'transportation-truck-list': 'List Trucks',
        'transportation-truck-update': 'Update Truck',
      },
      descriptions: {
        'crm-account-list':
          'Busca cuentas de CRM en base a un conjunto de filtros',
        'crm-account-get': 'Obtiene una cuenta específica por su ID',
        'crm-account-create': 'Crea una cuenta de CRM',
        'crm-account-delete': 'Elimina una cuenta de CRM',
        'crm-account-update': 'Actualiza una cuenta de CRM',
        'crm-accountAddress-create': 'Crea una dirección de cuenta',
        'crm-accountAddress-delete': 'Elimina una dirección de cuenta',
        'crm-accountAddress-get':
          'Obtiene una dirección de cuenta específica por su ID',
        'crm-accountAddress-list':
          'Busca direcciones de cuenta en base a un conjunto de filtros',
        'crm-accountAddress-update': 'Actualiza una dirección de cuenta',
        'crm-contact-list': 'Busca contactos de cuenta en el módulo de CRM',
        'crm-contact-create': 'Crea un contacto',
        'crm-contact-delete': 'Elimina un contacto',
        'crm-contact-get': 'Obtiene un contacto específico por su ID',
        'crm-contact-update': 'Actualiza un contacto',
        'crm-customerInvitation-accept': 'Acepta una invitación de cliente',
        'crm-customerInvitation-cancel': 'Cancela una invitación de cliente',
        'crm-customerInvitation-create': 'Crea una invitación de cliente',
        'crm-customerInvitation-get':
          'Obtiene una invitación de cliente por su ID',
        'crm-customerInvitation-getByToken':
          'Obtiene una invitación de cliente por su token',
        'crm-customerInvitation-list':
          'Busca invitaciones de cliente en base a un conjunto de filtros',

        'sales-salesOrder-list':
          'Busca órdenes de venta en base a un conjunto de filtros',
        'sales-salesOrder-get':
          'Obtiene una orden de venta específica por su ID',
        'sales-salesOrder-create': 'Crea una orden de venta',
        'sales-salesOrder-update': 'Actualiza una orden de venta',
        'sales-booking-create': 'Crea una reserva',
        'sales-booking-get': 'Obtiene una reserva específica por su ID',
        'sales-booking-list': 'Busca reservas en base a un conjunto de filtros',
        'sales-booking-update': 'Actualiza una reserva',
        'sales-deductionType-create': 'Crea un tipo de deducción',
        'sales-deductionType-delete': 'Elimina un tipo de deducción',
        'sales-deductionType-get':
          'Obtiene un tipo de deducción específico por su ID',
        'sales-deductionType-list':
          'Busca tipos de deducción en base a un conjunto de filtros',
        'sales-deductionType-update': 'Actualiza un tipo de deducción',
        'sales-load-create': 'Crea una carga',
        'sales-load-get': 'Obtiene una carga específica por su ID',
        'sales-load-list': 'Busca cargas en base a un conjunto de filtros',
        'sales-load-update': 'Actualiza una carga',
        'sales-loadReconciliation-delete': 'Elimina una conciliación de carga',
        'sales-loadReconciliation-update':
          'Actualiza una conciliación de carga',

        'inventory-item-list':
          'Lista y busca artículos de inventario (materiales) en la Biblioteca de Inventario',
        'inventory-item-get': 'Obtiene un artículo de inventario por su ID',
        'inventory-item-create': 'Crea un artículo de inventario',
        'inventory-item-delete': 'Elimina un artículo de inventario',
        'inventory-item-update': 'Actualiza un artículo de inventario',
        'inventory-category-create': 'Crea una categoría de inventario',
        'inventory-category-delete': 'Elimina una categoría de inventario',
        'inventory-category-get':
          'Obtiene una categoría de inventario específica por su ID',
        'inventory-category-list':
          'Busca categorías de inventario en base a un conjunto de filtros',
        'inventory-category-update': 'Actualiza una categoría de inventario',
        'inventory-inventoryTag-create': 'Crea una etiqueta de inventario',
        'inventory-inventoryTag-delete': 'Elimina una etiqueta de inventario',
        'inventory-inventoryTag-get':
          'Obtiene una etiqueta de inventario específica por su ID',
        'inventory-inventoryTag-list':
          'Busca etiquetas de inventario en base a un conjunto de filtros',
        'inventory-inventoryTag-update': 'Actualiza una etiqueta de inventario',
        'inventory-itemGroup-create':
          'Crea un grupo de artículos de inventario',
        'inventory-itemGroup-delete':
          'Elimina un grupo de artículos de inventario',
        'inventory-itemGroup-get':
          'Obtiene un grupo de artículos de inventario específico por su ID',
        'inventory-itemGroup-list':
          'Busca grupos de artículos de inventario en base a un conjunto de filtros',
        'inventory-itemGroup-update':
          'Actualiza un grupo de artículos de inventario',

        'core-customAttribute-create': 'Crea un atributo personalizado',
        'core-customAttribute-delete': 'Elimina un atributo personalizado',
        'core-customAttribute-get':
          'Obtiene un atributo personalizado específico por su ID',
        'core-customAttribute-list':
          'Busca atributos personalizados en base a un conjunto de filtros',
        'core-customAttribute-update': 'Actualiza un atributo personalizado',
        'core-customAttribute-validate': 'Valida un atributo personalizado',
        'core-facility-create': 'Crea una instalación',
        'core-facility-get': 'Obtiene una instalación específica por su ID',
        'core-facility-list':
          'Busca instalaciones en base a un conjunto de filtros',
        'core-facilityGroup-assignFacility':
          'Asigna una instalación a un grupo de instalaciones',
        'core-facilityGroup-create': 'Crea un grupo de instalaciones',
        'core-facilityGroup-get':
          'Obtiene un grupo de instalaciones específico por su ID',
        'core-facilityGroup-list':
          'Busca grupos de instalaciones en base a un conjunto de filtros',
        'core-facilityGroup-removeFacility':
          'Remueve una instalación de un grupo de instalaciones',
        'core-facilityGroup-update': 'Actualiza un grupo de instalaciones',
        'core-organization-create': 'Crea una organización',
        'core-organization-delete': 'Elimina una organización',
        'core-organization-get':
          'Obtiene una organización específica por su ID',
        'core-organization-list':
          'Busca organizaciones en base a un conjunto de filtros',
        'core-organization-update': 'Actualiza una organización',
        'core-scopedSettingValues-getBySetting':
          'Obtiene los valores de configuración con alcance para una configuración',
        'core-scopedSettingValues-patch':
          'Modifica los valores de configuración con alcance',
        'core-setting-create': 'Crea una configuración',
        'core-setting-delete': 'Elimina una configuración',
        'core-setting-get': 'Obtiene una configuración específica por su ID',
        'core-setting-list':
          'Busca configuraciones en base a un conjunto de filtros',
        'core-setting-update': 'Actualiza una configuración',
        'core-settingsGroup-create': 'Crea un grupo de configuraciones',
        'core-settingsGroup-delete': 'Elimina un grupo de configuraciones',
        'core-settingsGroup-get':
          'Obtiene un grupo de configuraciones específico por su ID',
        'core-settingsGroup-list':
          'Busca grupos de configuraciones en base a un conjunto de filtros',
        'core-settingsGroup-update': 'Actualiza un grupo de configuraciones',
        'core-user-create': 'Crea un usuario',
        'core-user-get': 'Obtiene un usuario específico por su ID',
        'core-user-list': 'Busca usuarios en base a un conjunto de filtros',

        'files-file-generateAccessURL':
          'Genera una URL de acceso para un archivo',
        'files-file-get': 'Obtiene un archivo específico por su ID',
        'files-file-list': 'Busca archivos en base a un conjunto de filtros',
        'files-fileTemplate-get': 'Obtiene una plantilla de archivo',
        'files-fileTemplate-list':
          'Busca plantillas de archivo en base a un conjunto de filtros',
        'files-fileTemplate-set': 'Establece una plantilla de archivo',
        'files-fileTemplate-remove': 'Remueve una plantilla de archivo',

        'finance-bill-create': 'Crea una factura de proveedor',
        'finance-bill-get':
          'Obtiene una factura de proveedor específica por su ID',
        'finance-bill-list':
          'Busca facturas de proveedor en base a un conjunto de filtros',
        'finance-financialAccount-create': 'Crea una cuenta financiera',
        'finance-financialAccount-list':
          'Busca cuentas financieras en base a un conjunto de filtros',
        'finance-invoice-create': 'Crea una factura',
        'finance-invoice-get': 'Obtiene una factura específica por su ID',
        'finance-invoice-list':
          'Busca facturas en base a un conjunto de filtros',
        'finance-payment-create': 'Crea un pago',
        'finance-payment-list': 'Busca pagos en base a un conjunto de filtros',

        'general-chart-create':
          'Crea visualizaciones de datos interactivas (gráficos de línea, área, barras, pastel, dispersión, burbuja) a partir de datos JSON',
        'general-dateTime': 'Retorna la fecha y hora actual',
        'general-python-execute':
          'Ejecuta código Python con bibliotecas precargadas: numpy, pandas, matplotlib, scipy, statsmodels',
        'general-userInput': 'Solicita entrada del usuario',

        'purchases-purchaseOrder-list':
          'Busca órdenes de compra en base a un conjunto de filtros',
        'purchases-purchaseOrder-get':
          'Obtiene una orden de compra específica por su ID',
        'purchases-purchaseOrder-create': 'Crea una orden de compra',
        'purchases-purchaseOrder-update': 'Actualiza una orden de compra',

        'transportation-asset-create': 'Crea un activo de transporte',
        'transportation-asset-delete': 'Elimina un activo de transporte',
        'transportation-asset-get':
          'Obtiene un activo de transporte específico por su ID',
        'transportation-asset-list':
          'Busca activos de transporte en base a un conjunto de filtros',
        'transportation-asset-update': 'Actualiza un activo de transporte',
        'transportation-assetType-create':
          'Crea un tipo de activo de transporte',
        'transportation-assetType-delete':
          'Elimina un tipo de activo de transporte',
        'transportation-assetType-get':
          'Obtiene un tipo de activo de transporte específico por su ID',
        'transportation-assetType-list':
          'Busca tipos de activo de transporte en base a un conjunto de filtros',
        'transportation-assetType-update':
          'Actualiza un tipo de activo de transporte',
        'transportation-containerType-create': 'Crea un tipo de contenedor',
        'transportation-containerType-delete': 'Elimina un tipo de contenedor',
        'transportation-containerType-get':
          'Obtiene un tipo de contenedor específico por su ID',
        'transportation-containerType-list':
          'Busca tipos de contenedor en base a un conjunto de filtros',
        'transportation-containerType-update':
          'Actualiza un tipo de contenedor',
        'transportation-driver-create': 'Crea un conductor',
        'transportation-driver-get':
          'Obtiene un conductor específico por su ID',
        'transportation-driver-list':
          'Busca conductores en base a un conjunto de filtros',
        'transportation-driver-update': 'Actualiza un conductor',
        'transportation-freightForwarder-create': 'Crea un agente de carga',
        'transportation-freightForwarder-delete': 'Elimina un agente de carga',
        'transportation-freightForwarder-get':
          'Obtiene un agente de carga específico por su ID',
        'transportation-freightForwarder-list':
          'Busca agentes de carga en base a un conjunto de filtros',
        'transportation-freightForwarder-update':
          'Actualiza un agente de carga',
        'transportation-freightLine-create': 'Crea una línea de flete',
        'transportation-freightLine-delete': 'Elimina una línea de flete',
        'transportation-freightLine-get':
          'Obtiene una línea de flete específica por su ID',
        'transportation-freightLine-list':
          'Busca líneas de flete en base a un conjunto de filtros',
        'transportation-freightLine-update': 'Actualiza una línea de flete',
        'transportation-hauler-add': 'Agrega un transportista',
        'transportation-hauler-remove': 'Remueve un transportista',
        'transportation-route-create': 'Crea una ruta',
        'transportation-route-get': 'Obtiene una ruta específica por su ID',
        'transportation-route-list':
          'Busca rutas en base a un conjunto de filtros',
        'transportation-route-update': 'Actualiza una ruta',
        'transportation-shippingCarrier-create':
          'Crea un transportista de envío',
        'transportation-shippingCarrier-delete':
          'Elimina un transportista de envío',
        'transportation-shippingCarrier-get':
          'Obtiene un transportista de envío específico por su ID',
        'transportation-shippingCarrier-list':
          'Busca transportistas de envío en base a un conjunto de filtros',
        'transportation-shippingCarrier-update':
          'Actualiza un transportista de envío',
        'transportation-task-create': 'Crea una tarea de transporte',
        'transportation-task-get':
          'Obtiene una tarea de transporte específica por su ID',
        'transportation-task-list':
          'Busca tareas de transporte en base a un conjunto de filtros',
        'transportation-task-update': 'Actualiza una tarea de transporte',
        'transportation-trailer-create': 'Crea un remolque',
        'transportation-trailer-get':
          'Obtiene un remolque específico por su ID',
        'transportation-trailer-list':
          'Busca remolques en base a un conjunto de filtros',
        'transportation-trailer-update': 'Actualiza un remolque',
        'transportation-transportationType-create':
          'Crea un tipo de transporte',
        'transportation-transportationType-delete':
          'Elimina un tipo de transporte',
        'transportation-transportationType-get':
          'Obtiene un tipo de transporte específico por su ID',
        'transportation-transportationType-list':
          'Busca tipos de transporte en base a un conjunto de filtros',
        'transportation-transportationType-update':
          'Actualiza un tipo de transporte',
        'transportation-truck-create': 'Crea un camión',
        'transportation-truck-get': 'Obtiene un camión específico por su ID',
        'transportation-truck-list':
          'Busca camiones en base a un conjunto de filtros',
        'transportation-truck-update': 'Actualiza un camión',
      },
      categories: {
        crm: 'CRM',
        sales: 'Ventas',
        inventory: 'Inventario',
        core: 'Core',
        files: 'Archivos',
        finance: 'Finanzas',
        general: 'General',
        purchases: 'Compras',
        transportation: 'Transporte',
        other: 'Otros',
      },
    },
    agents: {
      tabs: {
        all: 'Todos los tipos de agente',
        agent: 'Agentes',
        subAgents: 'Sub Agentes',
        prompt: 'Prompt',
        tools: 'Herramientas',
      },
      toolCount: {
        singular: 'herramienta',
        plural: 'herramientas',
      },
      header: {
        name: 'Nombre',
        type: 'Tipo',
        agentId: 'ID del Agente',
        status: 'Estado',
        provider: 'Proveedor',
        model: 'Modelo',
        tools: 'Herramientas',
        version: 'Versión',
        createdAt: 'Fecha de Creación',
        actions: 'Acciones',
      },
      type: {
        agent: 'Agente',
        subAgent: 'Sub Agente',
        fileProcessor: 'Procesador de Archivos',
      },
      status: {
        active: 'Activo',
        inactive: 'Inactivo',
      },
      details: {
        tabs: {
          configuration: 'Detalles',
        },
        sections: {
          basicInfo: 'Información Básica',
          tools: 'Herramientas Disponibles',
          modelConfig: 'Configuración del Modelo de IA',
        },
        fields: {
          name: {
            label: 'Nombre',
            placeholder: 'Ingrese el nombre del agente',
          },
          type: {
            label: 'Tipo',
            agent: {
              label: 'Agente',
              description:
                'Un agente principal aplica a todas las conversaciones',
            },
            subAgent: {
              label: 'Sub Agente',
              description:
                'Un sub agente es específico para una tarea particular',
            },
            fileProcessor: {
              label: 'Procesador de Archivos',
              description:
                'Preprocesa archivos y documentos usando un modelo de visión',
            },
          },
          agentIdentifier: {
            label: 'Identificador del Agente',
            placeholder: 'nombre-del-agente',
            validation: {
              pattern: 'Solo se permiten letras minúsculas, números y guiones',
            },
          },
          content: {
            label: 'Contenido',
            placeholder: 'Ingrese el contenido del agente...',
            description: 'El contenido que será utilizado por el agente de IA',
          },
          tools: {
            description:
              'Seleccione las herramientas disponibles para este agente',
            placeholder: 'Buscar y seleccionar herramientas',
          },
          isActive: {
            label: 'Activo',
            description:
              'Cuando está activo, este agente puede ser usado en conversaciones',
          },
          provider: {
            label: 'Proveedor',
            options: {
              gemini: 'Google Gemini',
              openai: 'OpenAI',
              anthropic: 'Anthropic',
              cerebras: 'Cerebras',
            },
          },
          model: {
            label: 'Modelo',
            placeholder:
              'ej., gemini-2.5-flash, gpt-4o, claude-sonnet-4-5, llama3.1-8b',
          },
          apiKey: {
            label: 'Clave API del Proveedor',
            placeholder:
              'Ingrese la clave API (deje en blanco para mantener la existente)',
          },
          baseUrl: {
            label: 'URL Base del Proveedor (Opcional)',
            placeholder: 'https://...',
          },
          temperature: {
            label: 'Temperatura',
          },
          reasoning: {
            label: 'Razonamiento',
          },
          reasoningBudget: {
            label: 'Presupuesto de Razonamiento',
          },
        },
      },
      actions: {
        create: 'Crear Agente',
        createAgent: 'Crear Agente',
        createSubAgent: 'Crear Sub Agente',
        createFileProcessor: 'Crear Procesador de Archivos',
        edit: 'Editar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        clearFilters: 'Limpiar Filtros',
        cancel: 'Cancelar',
        save: 'Guardar',
      },
      empty: {
        title: 'No se encontraron agentes',
        description: 'Cree un agente para comenzar',
      },
      notifications: {
        activated: 'Agente activado exitosamente',
        deactivated: 'Agente desactivado exitosamente',
        error: 'Error al guardar el agente. Por favor, intente de nuevo.',
      },
      searchPlaceholder: 'Buscar agentes por nombre...',
      filterByType: 'Filtrar por tipo',
      filterByStatus: 'Filtrar por estado',
      filterStatusAll: 'Activos e Inactivos',
      filterStatusActive: 'Activos',
      filterStatusInactive: 'Inactivos',
    },
    usage: {
      header: {
        organization: 'Organización',
        modelProvider: 'Proveedor',
        model: 'Modelo',
        totalTokens: 'Tokens Totales',
        totalCost: 'Costo Total',
        recordCount: 'Registros',
        period: 'Período',
        actions: 'Acciones',
      },
      filters: {
        dateRange: 'Período',
        modelProvider: 'Proveedor',
        model: 'Modelo',
        clearFilters: 'Limpiar Filtros',
        allProviders: 'Todos los Proveedores',
      },
      actions: {
        viewDetails: 'Ver Detalles',
      },
      empty: {
        title: 'Sin datos de uso',
        description:
          'No se encontraron métricas de uso de IA para los filtros seleccionados',
      },
      organizationDetail: {
        title: (orgName: string) => `Uso de ${orgName}`,
        summary: {
          totalTokens: 'Tokens Totales',
          totalCost: 'Costo Total',
          mostUsedModel: 'Modelo Más Usado',
          dateRange: 'Rango de Fechas',
        },
        tabs: {
          details: 'Registros Detallados',
        },
      },
    },
  },
  organizationDetailView: {
    tabs: {
      details: 'Detalles',
      entitlements: 'Habilitaciones',
    },
    sections: {
      basicInfo: 'Información Básica',
      facilities: 'Instalaciones',
      noFacilities: 'Sin instalaciones',
      users: 'Usuarios',
      noUsers: 'Sin usuarios',
    },
    fields: {
      name: 'Nombre',
      domain: 'Dominio',
      timezone: 'Zona Horaria',
      idpId: 'ID del Proveedor de Identidad',
      createdAt: 'Fecha de Creación',
      updatedAt: 'Fecha de Actualización',
    },
  },
  organizationListView: {
    searchPlaceholder: 'Buscar organizaciones por nombre o dominio...',
    header: {
      name: 'Nombre',
      domain: 'Dominio',
      createdAt: 'Fecha de Creación',
      updatedAt: 'Fecha de Actualización',
      userCount: 'Usuarios',
      status: 'Estado',
      actions: 'Acciones',
    },
    status: {
      onboarded: 'Incorporada',
      pending: 'Pendiente',
    },
    actions: {
      provision: 'Provisionar',
      viewDetails: 'Ver Detalles',
      edit: 'Editar',
      setAsOnboarded: 'Marcar como Incorporada',
      reset: 'Restablecer',
    },
    empty: {
      title: 'No se encontraron organizaciones',
      description: 'Intente ajustar su búsqueda o filtros.',
    },
  },
  organizationDetailsDialog: {
    title: {
      create: 'Nueva Organización',
      edit: 'Editar Organización',
    },
    fields: {
      name: {
        label: 'Nombre de la Organización',
        placeholder: 'Ingrese el nombre de la organización',
      },
      domain: {
        label: 'Dominio',
        placeholder: 'ejemplo.com',
        description: 'El dominio de correo electrónico para esta organización',
      },
      timezone: {
        label: 'Zona Horaria',
        placeholder: 'Seleccione una zona horaria',
      },
      idpId: {
        label: 'ID del Proveedor de Identidad',
        placeholder: 'Ingrese el ID de IDP (opcional)',
        description: 'Referencia externa del proveedor de identidad',
      },
    },
    actions: {
      cancel: 'Cancelar',
      create: 'Crear Organización',
      save: 'Guardar Cambios',
    },
    saveSuccess: {
      create: 'Organización creada exitosamente',
      update: 'Organización actualizada exitosamente',
    },
    saveError: 'Error al guardar la organización. Por favor, intente de nuevo.',
  },
  userListView: {
    searchPlaceholder: 'Buscar usuarios por nombre o correo electrónico...',
    filterByOrganization: 'Seleccionar organización',
    filterByStatus: 'Filtrar por estado',
    header: {
      name: 'Nombre',
      email: 'Correo Electrónico',
      organization: 'Organizaciones',
      phoneNumber: 'Teléfono',
      timezone: 'Zona Horaria',
      status: 'Estado',
      createdAt: 'Fecha de Creación',
      actions: 'Acciones',
    },
    status: {
      all: 'Todos los estados',
      active: 'Activo',
      archived: 'Archivado',
    },
    actions: {
      create: 'Agregar Usuario',
      edit: 'Editar',
      manageOrganizations: 'Gestionar Organizaciones',
      manageAdminAccess: 'Gestionar Acceso de Administrador',
      removeFromOrganization: 'Remover de la Organización',
      addToOrganization: 'Agregar a la Organización',
    },
    empty: {
      title: 'No se encontraron usuarios',
      description: 'Intente ajustar su búsqueda o filtros.',
      selectOrganization: 'Seleccione una organización',
      selectOrganizationDescription:
        'Por favor, seleccione una organización para ver sus usuarios.',
    },
  },
  userDetailsDialog: {
    title: {
      create: 'Nuevo Usuario',
      edit: 'Editar Usuario',
    },
    fields: {
      firstName: {
        label: 'Nombre',
        placeholder: 'Ingrese el nombre',
      },
      lastName: {
        label: 'Apellido',
        placeholder: 'Ingrese el apellido',
      },
      email: {
        label: 'Correo Electrónico',
        placeholder: 'usuario@ejemplo.com',
      },
      phoneNumber: {
        label: 'Número de Teléfono',
        placeholder: 'Ingrese el número de teléfono (opcional)',
      },
      organization: {
        label: 'Organización',
        placeholder: 'Buscar y seleccionar organización',
        description: 'El usuario será agregado a esta organización',
      },
      timezone: {
        label: 'Zona Horaria',
        placeholder: 'Seleccione una zona horaria',
      },
      idpId: {
        label: 'ID del Proveedor de Identidad',
        placeholder: 'Ingrese el ID de IDP (opcional)',
        description: 'Referencia externa del proveedor de identidad',
      },
    },
    actions: {
      cancel: 'Cancelar',
      create: 'Crear Usuario',
      save: 'Guardar Cambios',
    },
    saveSuccess: {
      create: 'Usuario creado exitosamente',
      update: 'Usuario actualizado exitosamente',
    },
    saveError: 'Error al guardar el usuario. Por favor, intente de nuevo.',
  },
  addUserToOrganizationDialog: {
    title: 'Agregar Usuario a la Organización',
    userInfo: 'Agregando usuario:',
    currentOrganizations: 'Organizaciones actuales:',
    noOrganizationsAvailable:
      'No hay organizaciones disponibles. Este usuario ya es miembro de todas las organizaciones.',
    fields: {
      organization: {
        label: 'Organización',
        placeholder: 'Buscar y seleccionar organización',
      },
    },
    actions: {
      cancel: 'Cancelar',
      add: 'Agregar a la Organización',
    },
    saveSuccess: 'Usuario agregado exitosamente a la organización',
    saveError:
      'Error al agregar el usuario a la organización. Por favor, intente de nuevo.',
  },
  manageUserOrganizationsDialog: {
    title: 'Gestionar Organizaciones del Usuario',
    userInfo: 'Gestionando organizaciones para:',
    currentOrganizations: 'Organizaciones',
    addOrganization: 'Agregar Organización',
    noOrganizationsAvailable:
      'No hay organizaciones disponibles para agregar. Este usuario ya es miembro de todas las organizaciones.',
    fields: {
      organization: {
        label: 'Organización',
        placeholder: 'Buscar y seleccionar organización para agregar',
      },
    },
    pendingChanges: {
      adding: '{count} organización(es) será(n) agregada(s)',
      removing: '{count} organización(es) será(n) removida(s)',
    },
    actions: {
      cancel: 'Cancelar',
      save: 'Guardar Cambios',
    },
    badges: {
      willRemove: 'En cola para remoción - Haga clic para deshacer',
      willAdd: 'Será agregada - Haga clic para cancelar',
      clickToRemove: 'Haga clic para remover del usuario',
    },
    saveSuccess: 'Cambios de organización guardados exitosamente',
    saveError:
      'Error al guardar los cambios de organización. Por favor, intente de nuevo.',
  },
  manageAdminAccessDialog: {
    title: 'Gestionar Acceso de Administrador',
    userInfo: 'Gestionando acceso de administrador para:',
    selectOrganization: 'Seleccionar Organización',
    instructions:
      'Otorgue o revoque el acceso de administrador para este usuario en la organización seleccionada.',
    fields: {
      organization: {
        placeholder: 'Buscar y seleccionar organización',
      },
    },
    actions: {
      cancel: 'Cancelar',
      grant: 'Otorgar Acceso de Administrador',
      revoke: 'Revocar Acceso de Administrador',
    },
    grantSuccess: 'Acceso de administrador otorgado exitosamente',
    grantError:
      'Error al otorgar acceso de administrador. Por favor, intente de nuevo.',
    revokeSuccess: 'Acceso de administrador revocado exitosamente',
    revokeError:
      'Error al revocar acceso de administrador. Por favor, intente de nuevo.',
  },

  resetOrganizationDialog: {
    title: 'Restablecer Organización',
    warningTitle: 'Advertencia:',
    warningDescription: (name: string) =>
      `Esta acción no se puede deshacer. Todos los datos existentes en "${name}" serán inaccesibles.`,
    consequencesTitle: 'Se realizarán las siguientes acciones:',
    consequences: [
      "La organización actual será renombrada con '[Eliminada]'",
      'Se creará una nueva organización con el nombre original',
      'Se creará una instalación predeterminada',
      'Los usuarios serán reasignados a la nueva organización',
      'Se cargarán las plantillas predeterminadas',
    ],
    confirmLabel: 'Escriba RESET para confirmar',
    actions: {
      cancel: 'Cancelar',
      reset: 'Restablecer Organización',
      resetting: 'Restableciendo...',
    },
    success: 'La organización ha sido restablecida exitosamente.',
    error:
      'Error al restablecer la organización. Por favor, inténtelo de nuevo.',
  },
  entitlements: {
    sidebar: {
      title: 'Habilitaciones',
      reports: 'Reportes',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
    },
    reports: {
      title: 'Configuración de Reportes',
      enabled: 'Habilitado',
      fields: {
        databaseName: 'Nombre de Base de Datos',
        username: 'Usuario',
        password: 'Contraseña',
        passwordPlaceholder: 'Dejar vacío para mantener la contraseña actual',
        host: 'Host',
        port: 'Puerto',
        ssl: 'SSL',
      },
      save: 'Guardar',
      saving: 'Guardando...',
      saveSuccess: 'Configuración de reportes guardada exitosamente',
      saveError:
        'Error al guardar la configuración de reportes. Por favor, intente de nuevo.',
    },
  },
  organizationSelect: {
    placeholder: 'Seleccionar organización',
  },
  logs: {
    rawPayloadParseError: 'Carga útil sin procesar (Error de análisis)',
    unknownEventType: 'Tipo de evento desconocido',
    unknownEvent: 'Evento desconocido',
    noDataAvailable: 'No hay datos disponibles',
    events: {
      organizationCreated: 'Organización Creada',
      organizationUpdated: 'Organización Actualizada',
      organizationDeleted: 'Organización Eliminada',
      organizationProvisioned: 'Organización Aprovisionada',
      entitlementGranted: 'Derecho Otorgado',
      entitlementRevoked: 'Derecho Revocado',
      signupCompleted: 'Registro Completado',
    },
  },
};
